import React, { Component, Fragment } from 'react';
import HeatMap from './HeatMap';
import ModuleExport from '../ModuleExport';
import { arrayOf, string, number, shape, func, any, bool, objectOf } from 'prop-types';
import cx from 'classnames';
import styles from './styles.scss';
import { FormControl, Select, MenuItem, MuiThemeProvider } from '@material-ui/core';
import { ADVISIT_BY_DAY_OF_WEEK_CHART_ID, newAdUsersMetricKey } from '../../helpers/constant';
import {
  checkEnableFeatureFlag,
  shouldShowNewAdUserSunsetDisclaimer,
  shouldShowTileByDateCompare,
} from '../../helpers/common';
import { withStyles, createTheme } from '@material-ui/core/styles';
import { get } from 'lodash';
import DeleteReportItemButton from '../DeleteReportItem';
import { NewAdUserSunsetDisclaimer } from '../DashboardTab/ChartDisclaimer';

export const typeOptions = [
  {
    type: 'adVisit/ads',
    yAxisTitle: 'Ad Visits/Ads',
    dropDownTitle: 'Ad Visits/Ads'
  },
  {
    type: 'adVisit',
    yAxisTitle: 'Ad Visits',
    dropDownTitle: 'Ad Visits'
  },
  {
    type: 'newAdUsers',
    yAxisTitle: 'New Ad Users',
    dropDownTitle: 'New Ad Users', 
    requiredFeatureFlags: [
      newAdUsersMetricKey
    ]
  }
];

const useStyles = {
  container: {},
  arrowDownIcon: {
    color: '#2196f3'
  }
};
const customStyles = createTheme({
  overrides: {
    MuiSelect: {
      selectMenu: {
        textOverflow: "clip",
      }
    }
  }
})

export class GAVisitByDayContainer extends Component {
  static propTypes = {
    data: arrayOf(shape({
      hour: string,
      weekday: string,
      value: number
    })),
    title: string,
    styleChart: shape({
      width: string,
      height: string
    }),
    campaign: shape({
      campaign_id: number
    }),
    setChartSelector: func,
    classes: shape({any}),
    fileName: string,
    isCustomReport: bool,
    showDeleteTimeOfDayChart: bool,
    isChartVisibleReport: shape({}),
    currentStep: string,
    itemIndex: number,
    timeOfDayChartSelector: objectOf(string),
    setReportChartSelector: func,
    enabledFlags: arrayOf(string),
    advertiser: advertiserShape,
  }

  static defaultProps = {
    fileName: 'web_total_visits_by_day_of_week'
  }

  handleTypeSelectionChange = (e) => {
    const { campaign, setChartSelector, setReportChartSelector, itemIndex, isCustomReport } = this.props;
    const selectedType = e.target.value;
    if(campaign) {
      setChartSelector(campaign.campaign_id, ADVISIT_BY_DAY_OF_WEEK_CHART_ID, { type: selectedType })
      isCustomReport
      && setReportChartSelector
      && setReportChartSelector(ADVISIT_BY_DAY_OF_WEEK_CHART_ID, itemIndex, { type: selectedType })
    }
  }

  handleUpdateData = () => {
    const { timeOfDayChartSelector, data } = this.props;
    const type = get(timeOfDayChartSelector, 'type', 'adVisit/ads');

    const filteredData = data && data.map(entry => {
      const { hour, weekday } = entry;
      let value = entry[type] || 0;
      if(type === 'adVisit/ads') {
        const ads = entry.ads;
        value = ads ? Number((entry['adVisit']/ads).toFixed(2)) : 0 ;
      } else if (type === "newAdUsers") {
        value = entry['newAdUsers'];
      }
      
      return {
        hour,
        weekday,
        value
      };
    });
    return filteredData;
  }

  drawDropdown() {
    const { classes, timeOfDayChartSelector, enabledFlags, campaign , advertiser } = this.props;
    const type = get(timeOfDayChartSelector, 'type', 'adVisit/ads');
    const isNewAdUserSelectorShow = shouldShowTileByDateCompare({advertiser, campaign});
    const options = typeOptions.filter(o => checkEnableFeatureFlag(enabledFlags, o.requiredFeatureFlags));
    const filterOptions = isNewAdUserSelectorShow ? options : options.filter((obj) => obj.type !== 'newAdUsers');
    
    return (
      <MuiThemeProvider theme={customStyles}>
        <FormControl className={styles.selectForm}>
          <Select
            value={type}
            onChange={this.handleTypeSelectionChange}
            className={styles.selectItem}
            inputProps={{
              classes : {
                icon: classes.arrowDownIcon
              }
            }}
          >
          {filterOptions.map( typeData => {
            return <MenuItem value={typeData.type} key={typeData.type}>{typeData.dropDownTitle}</MenuItem>
          })}
          </Select>
        </FormControl>
      </MuiThemeProvider>
    )
  }

  prepCsvData(data) {
    const { timeOfDayChartSelector } = this.props;
    const type = get(timeOfDayChartSelector, 'type', 'adVisit/ads');

    const isEnabledNewAdUsers = type === "newAdUsers";
    const headers =  isEnabledNewAdUsers
      ? ['Hour', 'Weekday', 'New Ad Users/Ads', 'New Ad Users']
      : ['Hour', 'Weekday', 'Ad Visits/Ads', 'Ad Visits'];

    return data && data.reduce((accum, currentEntry)=> {
      const { hour, weekday, ads, adVisit, newAdUsers } = currentEntry;
      const currentEntryNumber = isEnabledNewAdUsers ? newAdUsers : adVisit;
      const dataPerAd = ads ? Number((currentEntryNumber/ads).toFixed(2)) : 0;
      accum.push([hour, weekday, dataPerAd , currentEntryNumber ]);
      return accum;
    }, [headers]);
  }

  exportContainer = React.createRef();

  render () {
    const {
      data,
      title,
      styleChart,
      fileName,
      isCustomReport,
      showDeleteTimeOfDayChart,
      isChartVisibleReport,
      currentStep,
      itemIndex,
      timeOfDayChartSelector,
      campaign
    } = this.props;
    const { isTimeOfDayChartVisible } = isChartVisibleReport;
    const updatedData = this.handleUpdateData();
    const isNewAdUserSelected = get(timeOfDayChartSelector, 'type', 'adVisit/ads') === 'newAdUsers';

    return (
      <Fragment>
        {
          !isCustomReport || isCustomReport && isTimeOfDayChartVisible ?
          <div className={cx({[styles.containerMainView]: !isCustomReport}, styles.container)}>
            <div className={cx({[styles.itemContainer]: showDeleteTimeOfDayChart, [styles.deleteItemContainer]: currentStep === 'customize'})}>
              {showDeleteTimeOfDayChart &&
                <DeleteReportItemButton
                  isDelete={showDeleteTimeOfDayChart}
                  parentId="webAnalytics"
                  componentId="timeOfDayChart"
                  customClassName={styles.deleteButton}
                  itemIndex={itemIndex}
                />
              }
              <ModuleExport
                exportImg={this.exportContainer}
                data={this.prepCsvData(data)}
                fileName={fileName}
              />
              <div className={styles.heatMapChartExport} ref={this.exportContainer}>
                <div className={cx(styles.header)}>
                  <div className={cx(styles.headerTitle)}>{title}</div>
                </div>
                <div className={styles.selectPerformanceType}>
                  {this.drawDropdown()}
                </div>
                <div className={styles.GAVisitByDayChart} id={'GAVisitByDayChart' + itemIndex}>
                  <HeatMap data={updatedData} styleChart={styleChart}/>
                  {shouldShowNewAdUserSunsetDisclaimer(
                    campaign,
                    isNewAdUserSelected
                  ) && (
                    <NewAdUserSunsetDisclaimer
                      customStyle={styles.chartDisclaimer}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          : ''
        }
      </Fragment>
  )}
};

import { connect } from 'react-redux';
import { advertiserShape } from '../../helpers/propTypes';

function mapStateToProps(state) {
  return {
    currentStep: get(state, 'reportBuilder.currentStep'),
  }
}

export default connect(mapStateToProps)(withStyles(useStyles)(GAVisitByDayContainer));